import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  disabled: boolean
}

const Footer = ({ onClose, disabled }: Props) => {
  return (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.cancel')}
      </Button>
      <Button submit disabled={disabled}>
        {i18n.t('shift_management.coverage_section.automation.modal.submit')}
      </Button>
    </>
  )
}

export { Footer }
